import { ReactNode } from 'react';

import { useAbExperimentBucket } from 'hooks/abExperiment/useAbExperimentBucket';

import { ListingViewSidebarHolder } from './ListingViewSidebar.styled';

type Props = {
  id?: string;
  children: ReactNode;
  maxWidth?: number;
  qaId?: string;
};

export function ListingViewSidebar({ id, children, maxWidth, qaId }: Props) {
  const [bucketValue] = useAbExperimentBucket('NEW_SEARCH_2025_02');

  return (
    <ListingViewSidebarHolder
      id={id}
      data-qa-id={qaId}
      style={{ maxWidth }}
      $withFilters={bucketValue === 'ENABLED'}
    >
      {children}
    </ListingViewSidebarHolder>
  );
}
